import React, { useContext, useEffect, useState } from 'react';
import { Context_UI } from '../../Contexts/Context_UI';
import { useAuth } from '../../Contexts/AuthContext';
import { Templates_Get_All, Templates_Initialize, Templates_Update } from '../../api/API_Templates'
import UI_Button from '../ERUMAUI/UI_Button';
import UI_Input_Text from '../ERUMAUI/UI_Input_Text';
import UI_Divider from '../ERUMAUI/UI_Divider';
import Icon_Add from '../../Assets/Icons/Icon_Add.png'
import Icon_Delete from '../../Assets/Icons/Icon_Delete.png'
import { useTemplating } from '../../Contexts/Context_Templating';
import { useScheduleManagement } from '../../Contexts/Context_ScheduleManagement';
import UI_Form from '../ERUMAUI/UI_Form';
import UI_Horizontal_Tabs from '../ERUMAUI/UI_Horizontal_Tabs';
import UI_Icon from '../ERUMAUI/UI_Icons';
import UI_Toggle from '../ERUMAUI/UI_Toggle';
import UI_Card from '../ERUMAUI/UI_Card';
import Icon_Calendar from '../../Assets/Icons/Icon_Calendar.png';
import Icon_Table from '../../Assets/Icons/Icon_Table.png';
import Icon_Room from '../../Assets/Icons/Icon_Room.png';
import Icon_Map from '../../Assets/Icons/Icon_Map.png';
import Icon_Trail from '../../Assets/Icons/Icon_Trail.png';
import Icon_ReservationSlip from '../../Assets/Icons/Icon_ReservationSlip.png';
import Icon_User from '../../Assets/Icons/Icon_User.png';
import Icon_Reports from '../../Assets/Icons/Icon_Reports.png';
import { useAccounts } from '../../Contexts/Context_Accounts';



export default function Panel_Reporting_Center() {
    const { Account, Loading } = useAuth();
    // const [Template_List, Template_List_Set] = useState([]);
    const [Edited_Row, Edited_Row_Set] = useState({ Type: null, Type_2: null, Index: null });
    const [Edit_Buffer, Edit_Buffer_Set] = useState("");
    const { User_Permission } = useAccounts();
    const { Time_Parse } = useScheduleManagement();
    const UI = useContext(Context_UI);

    if (Loading) {
        return null;
    }
    return (
        <>
            <h2 className='General_Title'>
                Generate report document
            </h2>
            <div style={{ display: "flex", flexDirection: "row", flexWrap: "wrap", gap: "10px", marginTop: "10px" }}>
                {User_Permission?.Report?.ActivityLog    && (
                    <UI_Card
                        Type="Home"
                        Shape="Square"
                        Icon={Icon_Calendar}
                        Text="Monthly schedule report"
                        Destination='reports/monthlysched'
                    />
                )}
                {User_Permission?.Report?.ScheduleTimetable && (
                    <UI_Card
                        Type="Home"
                        Shape="Square"
                        Icon={Icon_Table}
                        Text="Schedule timetable"
                        Destination='reports/timetable'
                    />
                )}
                {User_Permission?.Report?.RoomUtilization && (
                    <UI_Card
                        Type="Home"
                        Shape="Square"
                        Icon={Icon_Room}
                        Text="Room utilization"
                        Destination='reports/roomutil'
                    />
                )}
                {User_Permission?.Report?.MapOverview && (
                    <UI_Card
                        Type="Home"
                        Shape="Square"
                        Icon={Icon_Map}
                        Text="Map overview"
                        Destination='reports/floorutil'
                    />
                )}
                {User_Permission?.Report?.ReservationSlip && (
                    <UI_Card
                        Type="Home"
                        Shape="Square"
                        Icon={Icon_ReservationSlip}
                        Text="Reservation slip"
                        Destination='reports/reservation'
                    />
                )}

            </div>
            {User_Permission?.Report?.AccountList || User_Permission?.Report?.ActivityLog ?
                <>
                    <h2 className='General_Title' style={{ marginTop: "10px" }}>
                        System report
                    </h2>
                    <div style={{ display: "flex", flexDirection: "row", flexWrap: "wrap", gap: "10px", marginTop: "10px" }}>
                        {User_Permission?.Report?.AccountList && (
                            <UI_Card
                                Type="Home"
                                Shape="Square"
                                Icon={Icon_User}
                                Text="Account list"
                                Destination='reports/accounts'
                            />
                        )}
                        {User_Permission?.Report?.ActivityLog && (
                            <UI_Card
                                Type="Home"
                                Shape="Square"
                                Icon={Icon_Trail}
                                Text="User trail"
                                Destination='reports/usertrail'
                            />
                        )}
                        {User_Permission?.Report?.ActivityLog && (
                            <UI_Card
                                Type="Home"
                                Shape="Square"
                                Icon={Icon_Reports}
                                Text="Activity log"
                                Destination='reports/log'
                            />
                        )}
                        

                    </div>
                </>
                :
                ""
            }

        </>
    );
}
